import { Breakdown } from "@xola/ui-kit";
import React from "react";
import { LineItem } from "types";
import { getPriceAndQuantity } from "./utils";

export const PartnerFeeLineItem = ({
    lineItem,
    initialPartnerFeeAmount,
}: {
    lineItem: LineItem;
    initialPartnerFeeAmount: number;
}) => {
    const isAmountChanged =
        (!lineItem.createdAt && lineItem.amount !== initialPartnerFeeAmount) ||
        (!lineItem.createdAt && initialPartnerFeeAmount === 0);

    return (
        <Breakdown.Item
            secondary={getPriceAndQuantity(lineItem)}
            value={lineItem.amount}
            color={isAmountChanged ? "primary" : "default"}
            data-testid="default-line-item"
            classNames={{ info: "no-translate" }}
        >
            {lineItem.name}
        </Breakdown.Item>
    );
};
